import React from "react";

function Footer() {
  return (
    <footer className="bg-gray-800 text-white p-4 text-center">
      <p>&copy; 2024 Abdullah Bueno</p>
      <div className="mt-2">
        <a href="https://www.linkedin.com/in/abueno803/" className="mx-2">
          LinkedIn
        </a>
        <a href="https://github.com/Bueno803" className="mx-2">
          GitHub
        </a>
        <a href="mailto:buenobusiness803@gmail.com" className="mx-2">
          Email
        </a>
      </div>
    </footer>
  );
}

export default Footer;
